import React from "react";
import ClassRoom from "../../Admin/Question/View/Background/ClassRoom";
import List from "./TrackList";

class Exams extends React.Component {
    render() {
        return <List {...this.props} typeOfList="Exams" defaultIndexValue={7} Background={<ClassRoom />} Link="/Tracks/Exams/" typeOfLesson="Exams" Icon="fal fa-pencil-alt" />;
    }
}
export default Exams;